import { render } from "./DuplicateBusinessModal.vue?vue&type=template&id=4b9f2d54&scoped=true"
import script from "./DuplicateBusinessModal.vue?vue&type=script&lang=js"
export * from "./DuplicateBusinessModal.vue?vue&type=script&lang=js"

import "./DuplicateBusinessModal.vue?vue&type=style&index=0&id=4b9f2d54&lang=stylus&scoped=true"
import "./DuplicateBusinessModal.vue?vue&type=style&index=1&id=4b9f2d54&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9f2d54"]])

export default __exports__